import { prepareHttpHeaders } from "../utils/http";
import env from "../utils/env";

/* eslint-disable no-useless-escape */
const MULTIPART_BOUNDARY = "TeladocMultiPartBoundary";

function arrayBufferToBase64(buffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  bytes.forEach(b => (binary += String.fromCharCode(b)));
  return window.btoa(binary);
}

function stringToBytes(string) {
  const bytes = new Uint8Array(string.length);
  for (let i = 0; i < string.length; i++) {
    bytes[i] = string.charCodeAt(i);
  }
  return bytes;
}

function fileToBytes(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", e => {
      resolve(new Uint8Array(e.target.result));
    });
    reader.readAsArrayBuffer(file);
  });
}

// TODO: Re-write uploadPhotoGenericRequest() to used this function for building the payload
export function prepareRawPhotoPayload(name, preview, type, memberId) {
  return fileToBytes(preview.file)
    .then(
      fileBytes =>
        new Uint8Array([
          ...stringToBytes(
            [
              `--${MULTIPART_BOUNDARY}`,
              `Content-Disposition: form-data; name=${name.replace(
                /\s/g,
                "_"
              )}; filename=${preview.file.name.replace(/\s/g, "_")};${
                type ? ` attachment_type_cd=${type};` : ""
              } member_id=${memberId}`,
              `Content-Type: ${preview.file.type}`,
              `Content-Length: ${preview.file.size}`,
              "\r\n"
            ].join("\r\n")
          ),
          ...fileBytes,
          ...stringToBytes("\r\n"),
          ...stringToBytes(`--${MULTIPART_BOUNDARY}--`)
        ])
    )
    .then(bytes => new Blob([bytes], { type: preview.file.type }));
}

export function uploadPhotoRequest(name, preview, type, memberId, raw, link) {
  if (raw) {
    return prepareRawPhotoPayload(name, preview, type, memberId).then(
      blob =>
        new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open("POST", `${env("BASE_URL")}${link}`);
          xhr.addEventListener("loadend", e => {
            if (e.target.status === 200) {
              resolve(JSON.parse(e.target.response).data);
            } else {
              reject(JSON.parse(e.target.response));
            }
          });
          const headers = prepareHttpHeaders({
            "Content-Type": `multipart\/form-data; boundary=${MULTIPART_BOUNDARY}`
          });
          Object.entries(headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value);
          });
          xhr.send(blob);
        })
    );
  }
  // Browser will add content-type automatically
  const { "Content-Type": contentType, ...headers } = prepareHttpHeaders();
  // const headers = prepareHttpHeaders();
  const formData = new FormData();
  formData.append(name, preview.file, preview.file.name);
  return fetch(`${env("BASE_URL")}photo_uploads`, {
    method: "POST",
    headers,
    body: formData
  })
    .then(res => {
      if (!res.ok) {
        throw new Error(res.json.meta.error);
      }
      return res.json();
    })
    .then(res => {
      if (!res.data && res.response_code !== 0) {
        return { error: res.error };
      }
      return { uuid: res.data.uuid };
    });
}

export function uploadPhotoGenericRequest(
  name,
  preview,
  type,
  memberId,
  identifier
) {
  return fileToBytes(preview.file)
    .then(
      fileBytes =>
        new Uint8Array([
          ...stringToBytes(
            [
              `--${MULTIPART_BOUNDARY}`,
              `Content-Disposition: form-data; name=${name.replace(
                /\s/g,
                "_"
              )}; filename=${preview.file.name.replace(/\s/g, "_")};${
                type ? ` attachment_type_cd=${type};` : ""
              } member_id=${memberId}`,
              `Content-Type: ${preview.file.type}`,
              `Content-Length: ${preview.file.size}`,
              "\r\n"
            ].join("\r\n")
          ),
          ...fileBytes,
          ...stringToBytes("\r\n"),
          ...stringToBytes(`--${MULTIPART_BOUNDARY}--`)
        ])
    )
    .then(
      bytes =>
        new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open(
            "POST",
            `${env("BASE_URL")}${
              identifier === "emo" ||
              identifier === "mhn" ||
              identifier === "edis"
                ? ""
                : "screens"
            }/photo_uploads`
          );
          xhr.addEventListener("loadend", e => {
            if (e.target.status === 200) {
              resolve(JSON.parse(e.target.response));
            } else {
              reject(JSON.parse(e.target.response));
            }
          });
          const headers = prepareHttpHeaders({
            "Content-Type": `multipart\/form-data; boundary=${MULTIPART_BOUNDARY}`
          });
          Object.entries(headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value);
          });
          const blob = new Blob([bytes], { type: preview.file.type });
          xhr.send(blob);
        })
    );
}

export function fetchImage(url) {
  const headers = prepareHttpHeaders({ Accept: "image/*" });
  return fetch(env("BASE_URL") + url, {
    responseType: "arraybuffer",
    headers: new Headers(headers)
  }).then(async response => {
    if (response.statusText !== "OK" && response.status !== 200) {
      return "";
    } else {
      const buffer = await response.arrayBuffer();
      const base64Flag = "data:image/jpeg;base64,";
      const imageStr = arrayBufferToBase64(buffer);
      return base64Flag + imageStr;
    }
  });
}
